// Host-configured discovery. No product IDs, fallback catalogs or write port.
const owners = new Map();
const aliases = new Map();
const values = new Map();
let activeCatalogs = null;

export function configureSystemColorUsages(systems) {
  activeCatalogs = null;
  owners.clear();
  aliases.clear();
  values.clear();
  for (const system of systems) {
    const usages = new Map();
    for (const feature of system.description?.features || []) {
      if (feature.id !== 'colors') continue;
      for (const usage of feature.colorUsages || []) {
        const key = JSON.stringify([system.systemId, usage.id]);
        const entry = { key, id: usage.id, descriptionVersion: system.description.version, featureVersion: feature.version };
        usages.set(usage.id, entry);
        for (const alias of usage.legacyKeys || []) {
          if (aliases.has(alias)) throw new Error('Doppelter Farbverwendungsalias.');
          aliases.set(alias, { owner: system.systemId, usageId: usage.id });

        }
      }
    }
    owners.set(system.systemId, usages);
  }
}
export function clearSystemColorOptions() { values.clear(); activeCatalogs = null; }
export function isColorCatalogSelectable(key) { return activeCatalogs === null || activeCatalogs.has(key); }
export function applySystemColorOptions(payload) {
  if (payload?.ok !== true || !Array.isArray(payload.systems)) throw new Error('Ungültige Systemoptionen.');
  const next = new Map();
  for (const system of payload.systems) {
    if (!owners.has(system.systemId)) throw new Error('Unbekannter Optionsbesitzer.');
    for (const option of system.options || []) {
      if (option.featureId !== 'colors') continue;
      const entry = owners.get(system.systemId).get(option.usageId);
      if (!entry || entry.id !== option.usageId || next.has(entry.key)
        || option.systemId !== system.systemId || entry.descriptionVersion !== option.descriptionVersion
        || entry.featureVersion !== option.featureVersion || typeof option.effective?.enabled !== 'boolean'
        || !Array.isArray(option.effective.catalogIds)
        || option.effective.catalogIds.some(key => typeof key !== 'string')) throw new Error('Ungültige Farbverwendung.');
      next.set(entry.key, Object.freeze(option.effective.enabled ? [...option.effective.catalogIds] : []));
    }
  }
  activeCatalogs = Array.isArray(payload.catalogs) ? new Set(payload.catalogs.filter(catalog => catalog.active === true).map(catalog => catalog.id)) : null;
  values.clear();
  next.forEach((value, key) => values.set(key, value));
}
export function systemColorCatalogIds(owner, usageId) {
  const target = aliases.get(usageId);
  const entry = owners.get(owner)?.get(usageId)
    || (target?.owner === owner ? owners.get(owner)?.get(target.usageId) : null);
  return Object.freeze([...(entry ? values.get(entry.key) || [] : [])]);
}
export function systemColorCatalogIdsForAlias(alias) {
  const target = aliases.get(alias);
  return target ? systemColorCatalogIds(target.owner, target.usageId) : null;
}
